import getProp from '@f/get-prop'

export const getSourceStatsKey = (workspaceSlug, date = 'onedayago') =>
  `${workspaceSlug}-${date}`

export const getSourceStatsRequest = (state, workspaceSlug, date) => {
  const key = getSourceStatsKey(workspaceSlug, date)
  const { isRequesting, didRequest, didRequestFail, error } = getProp(`sourceStats.${key}`, state)
  return { isRequesting, didRequest, didRequestFail, error }
}

export const getSourceStatsData = (state, workspaceSlug, date) => {
  const key = getSourceStatsKey(workspaceSlug, date)
  return getProp(`sourceStats.${key}.data`, state)
}



// WEBPACK FOOTER //
// ./selectors/source-stats.js